<template>
  <!-- 無期 -->
  <div class="koyou-kikan edit-item" v-if="editingData">
    <div class="head"><b>雇用期間</b></div>
    <div class="data flex flex-align-center">
      <div class="item">
        <date-picker class="date-picker" v-model="editingData.keiyaku_date" :clearable="false"
          :error="getError(editingData, 'keiyaku_date')" :disabled="disabled"></date-picker>
        <p class="current-data" v-if="currentData?.keiyaku_date">{{ currentData.keiyaku_date }}</p>
      </div>
      <p class="scale">から</p>

      <div class="item" v-if="
        editingData.koyou_type === OptionConst.KOYOU_TYPE.GEKKYUU_MUKI ||
        editingData.koyou_type === OptionConst.KOYOU_TYPE.PART_MUKI
      ">
        <p>{{ OptionConst.KOYOU_KEIYAKU_MUKI_LABEL }}</p>
        <p class="current-data" v-if="currentData?.koyou_end_date">{{ currentData.koyou_end_date }}</p>
        <p class="current-data" v-else>{{ OptionConst.KOYOU_KEIYAKU_MUKI_LABEL }}</p>
      </div>

      <div class="item" v-else>
        <date-picker class="date-picker" v-model="editingData.koyou_end_date" :clearable="false"
          :error="getError(editingData, 'koyou_end_date')" :disabled="disabled"></date-picker>
        <p class="current-data" v-if="currentData?.koyou_end_date">{{ currentData.koyou_end_date }}</p>
        <p class="current-data" v-else>{{ OptionConst.KOYOU_KEIYAKU_MUKI_LABEL }}</p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { useForm } from '@/composable/form/form';
import OptionConst from '@/const/Option';
import { KoyouKeiyakuDetail } from '@/types/KoyouKeiyakuDetail';
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    editingData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: null
    },
    currentData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: null
    },
    disabled: {
      type: Object as () => boolean,
      default: false
    }
  },
  setup() {
    const { getError } = useForm();
    return {
      OptionConst,
      getError
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/koyoukeiyaku.scss';
@import '@scss/components/koyoukeiyaku-edit.scss';

.koyou-kikan {
  .flex>* {
    margin-right: 10px;
  }
}
</style>
